/* eslint-disable react/jsx-no-undef */
/* eslint-disable react/style-prop-object */
/* eslint-disable array-callback-return */
/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import {
  Header,
  Footer,
  Loading,
  ShareButton,
  Snackbar,
} from '../../components/index'
import Rating from '@mui/material/Rating'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import 'react-lazy-load-image-component/src/effects/blur.css'
import { useParams } from 'react-router-dom'
import { FiHeart } from 'react-icons/fi'
import { AiOutlinePlus, AiOutlineMinus, AiOutlineFilePdf } from 'react-icons/ai'
import { WebApi } from '../../api/web'
import { Errors } from '../../utilities/error'
import { NumberWithCommas } from '../../utilities/generator'
import { UploadsUrl } from '../../services/url'
const Product = () => {
  const { id } = useParams()
  const [like, setLike] = useState(false)
  const [count, setCount] = useState(1)
  const [loading, setLoading] = useState(false)
  const [countLike, setCountLike] = useState(0)
  const [product, setProduct] = useState(null)
  const [rateProduct, setRateProduct] = useState(null)
  useEffect(() => {
    getProduct()
  }, [])

  const getProduct = async () => {
    await WebApi.product(id)
      .then((res) => {
        setProduct(res.data.data.product)
        setCountLike(res.data.data.product.countLike)
        setLike(res.data.data.product.like)
        if (res.data.data.product.rate < 6 && res.data.data.product.rate > -1) {
          setRateProduct(res.data.data.product.rate)
        } else {
          setRateProduct(0)
        }
      })
      .catch((err) => {})
  }

  useEffect(() => {
    if (rateProduct) {
      RateProduct()
    }
  }, [rateProduct])

  const RateProduct = async () => {
    await WebApi.rateLiProduct(id, rateProduct)
      .then((res) => {
        console.log('nnn', res.data)
      })
      .catch((err) => {
        Snackbar({
          title: 'نا موفق',
          message: Errors[err.response.data.errors[0].message],
          type: 'danger',
        })
      })
  }

  const LikeDisLike = async () => {
    setLoading(true)
    await WebApi.likeDislikeProduct(id)
      .then((res) => {
        setLoading(false)
        if (res.data.data.productLike.message == 1) {
          setCountLike(countLike + 1)
          setLike(true)
        } else {
          setCountLike(countLike - 1)
          setLike(false)
        }
      })
      .catch((err) => {
        setLoading(false)
      })
  }
  const settingCount = () => {
    if (count > 1) {
      setCount(count - 1)
    }
  }
  const AddCart = async (id) => {
    if (count > 0) {
      setLoading(true)
      await WebApi.addCart(id, count)
        .then((res) => {
          setLoading(false)
          setCount(1)
          Snackbar({
            message: 'محصول مورد نظر با موفقیت به سبد شما اضافه شد',
            type: 'success',
          })
        })
        .catch((err) => {
          setLoading(false)
          Snackbar({
            title: 'نا موفق',
            message: Errors[err.response.data.errors[0].message],
            type: 'danger',
          })
        })
    } else {
      Snackbar({
        title: 'خطا',
        message: 'کاربر گرامی حداقل تعداد محصول را وارد کنید',
        type: 'warning',
      })
    }
  }
  return (
    <>
      {loading && <Loading />}
      <Header title='جزئیات محصول' />
      {product ? (
        <div className='container'>
          <div className='template-pages'>
            <div className='top-section-single product-part'>
              <div className='click-top-section' onClick={() => LikeDisLike()}>
                {like ? (
                  <FiHeart size={25} fill={'#d81818'} color={'#d81818'} />
                ) : (
                  <FiHeart size={25} />
                )}
                {countLike > 0 && (
                  <div className='count-Likes'>{countLike}</div>
                )}
              </div>
              <div className='product-image'>
                <LazyLoadImage
                  className='box-shadow'
                  src={product.image}
                  alt={product.title}
                  effect='blur'
                  width='130px'
                  height='150px'
                  placeholderSrc={'/images/logo.png'}
                />
              </div>
              <ShareButton url={window.location.href} />
            </div>
            <div className='rate-book'>
              <Rating
                name='simple-controlled'
                value={rateProduct}
                onChange={(event, newValue) => {
                  setRateProduct(newValue)
                }}
                size='large'
              />
            </div>
            <div className='detail-book'>
              <h3>{product.title}</h3>
              <div className='nav-detail-book'>
                <div>
                  <span>دسته بندی : </span>
                  <span>{product.category.title}</span>
                </div>
                {/* {product.isDownloadable && (
                  <>
                    <div>/</div>
                    <div>
                      <span> نویسنده : </span>
                      <span>{product.author}</span>
                    </div>
                  </>
                )} */}
              </div>
            </div>
            <div className='layer-shadow'></div>
            <div className='price-product'>
              <h5>قیمت محصول</h5>
              {product.price != product.finalPrice && (
                <h5>
                  <del>{NumberWithCommas(product.price)}</del>
                </h5>
              )}
              <div className='price'>
                <span className='amount'>
                  {NumberWithCommas(product.finalPrice)}
                </span>
                <span>تومان</span>
              </div>
            </div>
            <div className='layer-shadow'></div>
            {!product.isDownloadable && (
              <>
                <div className='choose-count-product'>
                  <h5>انتخاب تعداد مورد نظر</h5>
                  <div className='setting'>
                    <span className='item' onClick={() => setCount(count + 1)}>
                      <AiOutlinePlus />
                    </span>
                    <span>{count}</span>
                    <span className='item' onClick={() => settingCount()}>
                      <AiOutlineMinus />
                    </span>
                  </div>
                </div>
                <div className='layer-shadow'></div>
              </>
            )}
            {product.pdf && product.isDownloadable && (
              <>
                <div className='single-product-bood-info'>
                  <div className='nav'>
                    <a
                      href={`${UploadsUrl}/${product.pdf}`}
                      download
                      className='item'
                      target='_blank'
                    >
                      <span>
                        <AiOutlineFilePdf size={23} />
                      </span>
                      <span>مشاهده بخشی از کتاب</span>
                    </a>
                  </div>

                  {/* <div className='nav'>
                <div className='item' onClick={() => setModalShow(true)}>
                  <span>
                    <ImGift size={23} />
                  </span>
                  <span>محصول را هدیه بده</span>
                </div>
              </div>
              
                    <GiftModal
              show={modalShow}
              onHide={() => setModalShow(false)}
              product={product}
              setModalShow={setModalShow}
              isDownloadable={product.isDownloadable}
            />
              */}
                </div>
                <div className='layer-shadow'></div>
              </>
            )}
            <div className='register-consulting'>
              <div className='price'>
                <span>قیمت :</span>
                <span className='amount'>
                  {NumberWithCommas(product.finalPrice * count)}
                </span>
                <span>تومان</span>
              </div>
              <div
                className='btn-register box-shadow'
                onClick={() => AddCart(product._id)}
              >
                افزودن به سبد خرید
              </div>
            </div>
          </div>
        </div>
      ) : (
        <Loading />
      )}
      <Footer />
    </>
  )
}
export default Product
